// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B9yK","field":"styles_field__19w1k","fieldCol":"styles_fieldCol__2uGFn","diffCol":"styles_diffCol__35KU4","diff":"styles_diff__3rmmc"};